export const formHelperText = {
  root: {
    paddingLeft: 5,
  },
};

export const formLabel = {
  root: {
    fontSize: 14,
  },
};

export const inputLabel = {
  formControl: {
    top: 12,
    left: 10,
    transform: 'translate(0, 22px) scale(1)',
  },
  shrink: {
    transform: 'translate(0, 13px) scale(0.7)',
    zIndex: 1,
  },
  filled: {
    transform: 'translate(2px, 6px) scale(1)',
    '&$shrink': {
      transform: 'translate(0px, -6px) scale(0.75)',
    },
  },
  outlined: {
    transform: 'translate(2px, 6px) scale(1)',
    '&$shrink': {
      transform: 'translate(4px, -16px) scale(0.75)',
    },
  },
};

export const formControl = {
  root: {
    '& label + div': {
      alignItems: 'flex-end',
      '&[role="radiogroup"]': {
        alignItems: 'flex-start',
      },
      paddingBottom: 4,
      '& input, > div, > select': {
        padding: '24px 8px 0',
      },
    },
  },
};
